import { Steps as ArkSteps } from "@ark-ui/react/steps"
import cx from "classnames"

export interface StepItem {
  label: string
  description?: string
  important?: boolean
}

export type StepsPropsType = { items: StepItem[] }

export const Steps = ({ items }: StepsPropsType) => {
  return (
    <ArkSteps.Root
      className="cobalt-steps"
      count={items.length}
      orientation="vertical"
    >
      {items.map((item, index) => {
        const itemKey = index
        return (
          <ArkSteps.Item
            key={itemKey}
            index={index}
            className={cx("cobalt-steps__item", {
              "cobalt-steps__item--important": item.important,
            })}
          >
            <div className="cobalt-steps__item__wrapper">
              <ArkSteps.Indicator className="cobalt-steps__item__indicator" />
              <div className="cobalt-steps__item__content">
                <div className="cobalt-steps__item__label">{item.label}</div>
                <div className="cobalt-steps__item__description">
                  {item.description}
                </div>
              </div>
            </div>
            <ArkSteps.Separator className="cobalt-steps__item__separator" />
          </ArkSteps.Item>
        )
      })}
    </ArkSteps.Root>
  )
}
